/* istanbul ignore file */
import Vue from 'vue';
import App from './App.vue';
import formatPrice from './helpers/formatPrice';

Vue.config.productionTip = false;
Vue.prototype.$formatPrice = formatPrice;

new Vue({
  render: h => h(App),
}).$mount('#app');
